import { render } from "./AvailableTag.vue?vue&type=template&id=619342ec&scoped=true"
import script from "./AvailableTag.vue?vue&type=script&lang=js"
export * from "./AvailableTag.vue?vue&type=script&lang=js"

import "./AvailableTag.vue?vue&type=style&index=0&id=619342ec&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-619342ec"]])

export default __exports__